import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "../Footer";

const NotFound = () => {
  return (
    <>
      <Navbar />
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "70vh" }}
      >
        <div className="text-center pt-5">
          <h1
            className="fw-bold"
            style={{ fontSize: "6rem", color: "#00889c" }}
          >
            404
          </h1>
          <h4 className="fw-semibold mb-3">Page Not Found</h4>
          <p className="text-muted mb-4" style={{ maxWidth: "400px" }}>
            The page you are looking for doesn't exist or has been moved. Please
            check the URL or go back to the homepage.
          </p>
          <Link
            to="/"
            className="decided-btn"
            style={{ textDecoration: "none" }}
          >
            <i className="fa-solid fa-house me-2"></i>
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
